import React, { useEffect } from "react";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { TextField } from "@material-ui/core";
import axios from "axios";
import Fab from "@material-ui/core/Fab";
import EditIcon from "@material-ui/icons/Edit";
import UserIcon from "@material-ui/icons/Person";
import CircularProgress from "@material-ui/core/CircularProgress";
import api from "../common/api";
import { Container, Row, Col } from "shards-react";
import Backdrop from "@material-ui/core/Backdrop";
import Typography from "@material-ui/core/Typography";

const getMuiTheme = () =>
  createMuiTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: "0px 8px 0px 8px",
          fontSize: "0.73rem"
        }
      },
      MuiFormLabel: {
        root: {
          fontSize: "0.75rem"
        }
      },
      MuiInputBase: {
        root: {
          fontSize: "0.75rem"
        }
      },
      MuiTypography: {
        body1: {
          fontSize: "0.75rem"
        }
      }
    }
  });

const DashboardUsers = () => {
  const [users, setUsers] = React.useState([]);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [backdrop, setBackdrop] = React.useState(false);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [errors, setErrors] = React.useState(false);
  const token = localStorage.getItem("userToken");
  const getUsers = async () => {
    try {
      const res = await axios.get(api.dashboardUsers().index(), {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUsers(res.data);
      setIsLoaded(true);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  const handleImpersonate = async userID => {
    try {
      const body = {
        user_id: userID
      };
      const res = await axios.post(api.dashboardUsers().impersonate(), body, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const dashboardURL = res.data.url;
      window.open(dashboardURL, "_blank");
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
  const handleDownload = async () => {
    setBackdrop(true);
    var formData = new FormData();
    const token = localStorage.getItem("userToken");
    await axios
      .post(api.dashboardUsers().export(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        window.location.href = response.data;
      })
      .catch(error => {
        alert("Falló la descarga");
      }).finally(() => {
        setBackdrop(false);
      });
  };
  const columns = [
    {
      name: "id",
      label: "Id",
      options: {
        filter: false,
        sort: true,
        display: false
      }
    },
    {
      name: "subcontact.contact.hansa_code",
      label: "Hansa Code",
      options: {
        filter: true,
        filterType: "textField",
        sort: true,
        display: true
      }
    },
    {
      name: "subcontact.firstname",
      label: "Nombre",
      options: {
        filter: true,
        filterType: "textField",
        sort: true
      }
    },
    {
      name: "subcontact.lastname",
      label: "Apellido",
      options: {
        filter: true,
        filterType: "textField",
        sort: true
      }
    },
    {
      name: "email",
      label: "Email",
      options: {
        filter: true,
        filterType: "textField",
        sort: true
      }
    },
    {
      name: "client",
      label: "Cliente",
      options: {
        filter: true,
        filterType: "select",
        sort: true,
        display: false
      }
    },
    {
      name: "subcontact.id",
      label: "Id Subcontacto",
      options: {
        filter: false,
        display: false
      }
    },
    {
      name: "Acciones",
      label: "",
      options: {
        filter: false,
        setCellHeaderProps: () => ({ align: "center" }),
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowId = tableMeta.rowData[0];
          const userID = tableMeta.rowData[0];
          const subcontactID = tableMeta.rowData[6];
          //const rowId = 1
          return (
            <div className="row" style={{ display: "block" }}>
              {rowId ? (
                <Fab
                  color="primary"
                  aria-label="view"
                  variant="extended"
                  style={{ boxShadow: "none", backgroundColor: "green" }}
                  fontSize="small"
                  className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                  href={"/dashboard/user/" + subcontactID}
                >
                  <EditIcon fontSize="small" />
                </Fab>
              ) : (
                ""
              )}
              {rowId ? (
                <Fab
                  color="primary"
                  aria-label="view"
                  variant="extended"
                  style={{ boxShadow: "none", backgroundColor: "green" }}
                  fontSize="small"
                  className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                  onClick={() => handleImpersonate(userID)}
                >
                  <UserIcon fontSize="small" />
                </Fab>
              ) : (
                ""
              )}
            </div>
          );
        }
      }
    }
  ];

  const options = {
    print: false,
    responsive: "stacked",
    selectableRowsOnClick: true,
    download: true,
    onDownload: () => {
      handleDownload();
      return false;
    },
    rowsPerPage: 10,
    textLabels: {
      toolbar: {
        search: "Buscar",
        viewColumns: "Ver columnas",
        filterTable: "Filtros",
        downloadCsv: "Exportar XLS"
      },
      body: {
        noMatch: isLoaded ? "No hay resultados" : <CircularProgress />
      },
      selectedRows: {
        text: "fila(s) seleccionadas"
      },
      viewColumns: {
        title: "Ver columnas"
      },
      pagination: {
        next: "Siguiente",
        previous: "Anteior",
        rowsPerPage: "Cantidad por página:",
        displayRows: "de"
      },
      filter: {
        all: "Todos",
        title: "Filtros",
        reset: "Limpiar"
      }
    }
  };
  return (
    <Container fluid className="main-content-container px-4">
      <Row>
        <Col className="p-2">
          <Backdrop
            open={backdrop}
            onClick={() => setBackdrop(false)}
            style={{ zIndex: 10000, color: "#3f51b5" }}
          >
            <CircularProgress color="inherit" />{" "}
            <Typography className="ml-2" variant="h5" color="primary">
              Descargando...
            </Typography>
          </Backdrop>
          <MuiThemeProvider theme={getMuiTheme()}>
            <MUIDataTable
              title="Lista de Usuarios Dashboard"
              data={Object.values(users)}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </Col>
      </Row>
    </Container>
  );
};

export default DashboardUsers;
